import { render, staticRenderFns } from "./other_debts.vue?vue&type=template&id=730a9335&"
import script from "./other_debts.vue?vue&type=script&lang=js&"
export * from "./other_debts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports